module.exports = {
  title: {
    nav: [{
        title: 'HOME',
        path: '/homeen'
      },
      {
        title: 'ABOUT',
        path: '/profileen'
      },
      {
        title: 'PRODUCTS',
        path: '/producten'
      },
      {
        title: 'EQUIPMENTS AND SOLUTIONS',
        path: '/deviceen'
      },
      {
        title: 'INVESTMENT',
        path: '/investen'
      },
      {
        title: 'CAREER',
        path: '/recruiten'
      },
      {
        title: 'FEEDBACK',
        path: '/bbsen'
      },
      {
        title: 'CONTACT',
        path: '/contacten'
      }
    ]
  },
  images: {
    a00index1_02: require('../img/en/00index1_02.jpg'),
    a00index1_03: require('../img/en/00index1_03.jpg'),
    a1_02: require('../img/en/1_02.jpg'),
    ff_06: require('../img/en/ff_06.jpg')
  },
  text: {
    top1: 'Set as homepage',
    top2: 'Add to Favorites',
    search: 'Search',
    bott1: 'coryright@2011 CHINA MATERIAL INTERNATIONAL CO., LTD. all rights reserved 京ICP备05044301号'
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/en.js